import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  row: {
    justifyContent: 'flex-start',
  },
  iconColumn: {
    width: 34,
    alignItems: 'center',
    position: 'relative',
  },
  halfBar: {
    width: 10,
    overflow: 'hidden',
  },
  iconSkeleton: {
    position: 'absolute',
    left: 0,
    zIndex: 2,
    height: 34,
    width: 34,
    borderRadius: 50,
  },
  contentContainer: {
    marginLeft: 12,
    justifyContent: 'center',
    paddingBottom: 10,
    flex: 1,
  },
  contentBox: {
    borderWidth: 2,
    borderRadius: 7,
  },
  firstStepContent: {
    margin: 15,
    gap: 10,
  },
  otherStepContent: {
    margin: 15,
    gap: 10,
  },
});
